import React, { useState } from "react";
import { ToggleSwitch } from "../common/RouteRow";
import LineGroup from "./LineGroup";
import { ChevronIcon, CityIcon } from "./treeIcons";

export default function CityCard({
    cityObj, hiddenRoutes, selectedCities, loadingCities, setLoadingCities,
    toggleRouteGroup, toggleCity, expandedKeys, toggleExpanded,
    openBusDetails, focusOnLocation
}) {
    const { citId, cityName, lines, routeIds: allRouteIds, activeRoutesCount, activeBusesCount, totalRoutes } = cityObj;

    const [isExpanded, setIsExpanded] = useState(true);
    const isAnyRouteOn = allRouteIds.some(id => !hiddenRoutes.has(id));
    const isCityLoading = loadingCities.has(citId);

    // Toggle de una ruta o de una linea entera; tocar algo de la ciudad la selecciona en el mapa.
    const toggleRoutes = (routeIds) => {
        const done = toggleRouteGroup(routeIds);
        if (!selectedCities.has(citId)) toggleCity(citId);
        return done;
    };

    const handleMasterCityToggle = async () => {
        if (isCityLoading) return; 
        
        setLoadingCities(prev => new Set(prev).add(citId));

        try {
            await new Promise(resolve => setTimeout(resolve, 50));
            if (isAnyRouteOn) {
                const routesCurrentlyOn = allRouteIds.filter(id => !hiddenRoutes.has(id));
                if (routesCurrentlyOn.length > 0) {
                    await toggleRouteGroup(routesCurrentlyOn);
                }
            } else {
                const routesCurrentlyOff = allRouteIds.filter(id => hiddenRoutes.has(id));
                if (routesCurrentlyOff.length > 0) {
                    await toggleRouteGroup(routesCurrentlyOff);
                }
                if (!selectedCities.has(citId)) toggleCity(citId);
            }
            await new Promise(resolve => setTimeout(resolve, 500));
        } finally {
            setLoadingCities(prev => {
                const next = new Set(prev);
                next.delete(citId);
                return next;
            });
        }
    };

    return (
        <section className={`mon-city${isAnyRouteOn ? " is-on" : ""}`}>
            <div className="mon-city-head">
                <button type="button" className="mon-row-toggle" onClick={() => setIsExpanded(v => !v)} aria-expanded={isExpanded}>
                    <ChevronIcon isOpen={isExpanded} />
                    <span className="mon-city-icon"><CityIcon size={17} /></span>
                    <span className="mon-text">
                        <span className="mon-city-name">{cityName}</span>
                        <span className="mon-city-meta">
                            <span className={`mon-chip${activeBusesCount > 0 ? " is-live" : ""}`}>
                                {activeBusesCount > 0 && <span className="mon-live-dot" />}
                                {activeBusesCount > 0 ? `${activeBusesCount} ${activeBusesCount === 1 ? 'bus' : 'buses'}` : 'Sin buses'}
                            </span>
                            <span className="mon-chip">{activeRoutesCount}/{totalRoutes} rutas</span>
                        </span>
                    </span>
                </button>
                <ToggleSwitch 
                    isOn={isAnyRouteOn} 
                    onToggle={handleMasterCityToggle} 
                    isBusy={isCityLoading} 
                    label={`Mostrar todas las rutas de ${cityName} en el mapa`} 
                />
            </div>

            {isExpanded && (
                <div className="mon-city-body">
                    {totalRoutes === 0 ? (
                        <p className="mon-empty">Aún no hay rutas permisibles configuradas.</p>
                    ) : (
                        lines.map(line => {
                            const lineKey = `${citId}:${line.surId ?? 'none'}`;
                            return (
                                <LineGroup 
                                    key={lineKey}
                                    line={line}
                                    lineKey={lineKey}
                                    hiddenRoutes={hiddenRoutes}
                                    expandedKeys={expandedKeys}
                                    toggleExpanded={toggleExpanded}
                                    toggleRoutes={toggleRoutes}
                                    openBusDetails={openBusDetails}
                                    focusOnLocation={focusOnLocation}
                                />
                            );
                        })
                    )}
                </div>
            )}
        </section>
    );
}
